import posthog from 'posthog-js';

export const posthogUserCaptureEvent = (userData, captureEvent) => {

  const eventData = {
    user_id: userData?._id,
    profile_type: 'registered',
    timestamp: new Date().toISOString(),
  };

  try {
    posthog.capture(captureEvent, eventData);
  } catch (error) {
    console.error('PostHog capture failed:', error);
  }
};

export const posthogAnonymousUserCaptureEvent = (currentId, captureEvent) => {

  const eventData = {
    distinct_id: currentId,
    timestamp: new Date().toISOString(),
  };

  try {
    posthog.capture(captureEvent, eventData);
  } catch (error) {
    console.error('PostHog capture failed:', error);
  }
};

export const posthogUserIdentifyPikkoUserEvent = (userData) => {

  const eventData = {
    email: userData?.email || '',
    name: userData?.name || '',
    phone_number: userData?.phoneNumber || '',
    user_id: userData?._id,
    user_type: 'registered',
    last_seen: new Date().toISOString(),
  };

  try {
    posthog.identify(userData?._id, {
      $set: eventData,
    });
  } catch (error) {
    console.error('PostHog capture failed:', error);
  }

};

export const posthogUserIdentifyAnonymousUserEvent = (currentId) => {

  const eventData = {
    user_type: 'anonymous',
    first_seen: new Date().toISOString(),
    browser: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
  };

  try {
    posthog.identify(currentId, {
      $set: eventData,
    });
  } catch (error) {
    console.error('PostHog capture failed:', error);
  }

};
